import React, { useState, useEffect } from 'react';
import { Link, navigate } from "gatsby";
import { signOut, onAuthStateChanged } from 'firebase/auth'; 
import { auth } from '../../config/firebase';

import ApprelyLogoIcon from "../../assets/images/logo/apprely-logo.svg";
import Darrow from "../../assets/images/Icons/admin/downarrow.svg";
import Plogo from "../../assets/images/Icons/admin/profilelogo.svg";

const Navbar = () => {

    const [username, setUsername] = useState('');
    
    useEffect(() => {
        const storedUsername = localStorage.getItem('username');
        if (storedUsername) {
            setUsername(storedUsername);
        }
        }, []);

    const handleLogout = () => {
    signOut(auth).then(() => {
        navigate('/admin/hr-admin-login'); 
    }).catch((error) => {
        console.error("Error during logout:", error);
    });
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (!currentUser) {
                navigate('/admin/hr-admin-login'); 
            }
        });
    
        return () => unsubscribe();
      }, []);

  return (
    <div className="admin-main-header">
        <div className="admin-logo">
            <img src={ApprelyLogoIcon} alt={ApprelyLogoIcon} className="logo"height="100"/>
        </div>
        <div className="user-info">
            <div className="dropdown">
                <a
                href="#"
                role="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >

                {username && (
                    <div className="user-container">
                    <img src={Plogo} alt="arrow" className="user-icon"/>
                    <span className="user-name">{username}</span>
                    <img src={Darrow} alt="arrow" className="user-icon1" />
                    </div>
                )}
                </a>
                <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
                style={{ listStyleImage: "none", listStyleType: "none" }}
                >
                <div className="dropwdown-top-angle__arrow"></div>
                <Link
                    className="dropdown-item"
                    aria-current="page"
                    to={""}
                    onClick={handleLogout}
                >
                    <li
                    onClick={handleLogout}
                    data-bs-toggle="collapse"
                    data-bs-target=".navbar-collapse.show"
                    >
                    <span>Logout</span>
                    </li>
                </Link>
                </ul>
            </div>
        </div>
    </div>
  );
}

export default Navbar;